import { Host } from '../../index'

const OperationMenuMenus = `${Host}admin/operation/menu/menus`

export default {
    OperationMenuMenus
}
